import { SnackbarAction } from '../actions/snackbar'

export interface SnackbarState {
  message: string
  open: boolean
}

const initialState: SnackbarState = {
  message: '',
  open: true
}

const snackbar = (state: SnackbarState = initialState, action: SnackbarAction): SnackbarState => {
  switch (action.type) {
    case 'SET_SNACKBAR_MESSAGE':
      return {
        ...state,
        message: action.value
      }
    case 'CLEAR_SNACKBAR':
      return { ...initialState }
    default:
      return state
  }
}

export default snackbar
